import * as yup from "yup";

const isKeycloakEnabled = process.env.REACT_APP_ENABLE_KEYCLOAK === 'true';

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("Registered Name"),
  /*   pocName: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("First Name"),
  pocContact: yup
    .string()
    .required()
    .matches(/^[0-9]+$/, "Please enter valid contact number")
    .min(10)
    .max(10)
    .label("Contact Phone Number"), */
  operatingStates: yup.array().min(1).required().label("Operating State"),
  address: yup.object().shape({
    addressLine1: yup
      .string()
      .required()
      .matches(/^(?!\s+$).+/, "Please provide valid values in address field")
      .label("Address Line 1"),
    addressLine2: yup.string().label("Address Line 2"),
    country: yup.string().required().label("Country"),
    state: yup.string().required().label("State"),
    city: yup.string().required().label("City"),
    pincode: yup
      .string()
      .required()
      .matches(/^[0-9]+$/, "Please enter valid pincode")
      .min(6)
      .max(6)
      .label("Pincode"),
  }),
  user: yup.object().shape({
    firstName: yup
      .string()
      .required()
      .matches(/^(?!\s+$).+/, "Please provide valid value in First Name field")
      .label("First Name"),
    lastName: yup.string().label("Last Name"),
    email: yup.string().email().required().label("Business Email"),
    password: isKeycloakEnabled
      ? yup.string().label("Password")
      : yup.string().required().label("Password"),
    phone: yup
      .string()
      .required()
      .matches(/^[0-9]+$/, "Please enter valid contact number")
      .min(10)
      .max(10)
      .label("Contact Phone Number"),
  }),
  testingScope: yup.mixed().label("Testing Scope"),
  contract: yup.mixed().label("Contract"),
});

export default schema;
